import React from 'react';
import Scatter from '@splunk/dashboard-visualizations/Scatter';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicCode from '!!raw-loader!./examples/Basic';
import TitleVisibilityCode from '!!raw-loader!./examples/TitleVisibility';
import TitleSpecifiedCode from '!!raw-loader!./examples/TitleSpecified';
import SeriesColorsCode from '!!raw-loader!./examples/SeriesColors';
import FieldColorsCode from '!!raw-loader!./examples/FieldColors';
import BackgroundColorCode from '!!raw-loader!./examples/BackgroundColor';
import ForegroundColorCode from '!!raw-loader!./examples/ForegroundColor';
import FontColorCode from '!!raw-loader!./examples/FontColor';
import AbbreviationCode from '!!raw-loader!./examples/Abbreviation';
import AxisYScaleCode from '!!raw-loader!./examples/AxisYScale';
import AxisXScaleCode from '!!raw-loader!./examples/AxisXScale';
import AxisYMinNumberCode from '!!raw-loader!./examples/AxisYMinNumber';
import AxisYMaxNumberCode from '!!raw-loader!./examples/AxisYMaxNumber';
import AxisYMajorUnitCode from '!!raw-loader!./examples/AxisYMajorUnit';
import AxisXMinNumberCode from '!!raw-loader!./examples/AxisXMinNumber';
import AxisXMaxNumberCode from '!!raw-loader!./examples/AxisXMaxNumber';
import AxisXMajorUnitCode from '!!raw-loader!./examples/AxisXMajorUnit';
import AxisXLabelRotationCode from '!!raw-loader!./examples/AxisXLabelRotation';
import AxisXVisibilityHideCode from '!!raw-loader!./examples/AxisXVisibilityHide';
import AxisXVisibilityCode from '!!raw-loader!./examples/AxisXVisibility';
import AxisYVisibilityCode from '!!raw-loader!./examples/AxisYVisibility';
import AxisYMajorTicksCode from '!!raw-loader!./examples/AxisYMajorTicks';
import AxisXMajorTicksCode from '!!raw-loader!./examples/AxisXMajorTicks';
import AxisYMinorTicksCode from '!!raw-loader!./examples/AxisYMinorTicks';
import AxisXMinorTicksCode from '!!raw-loader!./examples/AxisXMinorTicks';
import AxisXTicksSizeCode from '!!raw-loader!./examples/AxisXTicksSize';
import AxisYTicksSizeCode from '!!raw-loader!./examples/AxisYTicksSize';
import LabelVisibilityCode from '!!raw-loader!./examples/LabelVisibility';
import AxisXExtendRangeFalseCode from '!!raw-loader!./examples/AxisXExtendRangeFalse';
import AxisXExtendRangeTrueCode from '!!raw-loader!./examples/AxisXExtendRangeTrue';
import AxisYExtendRangeFalseCode from '!!raw-loader!./examples/AxisYExtendRangeFalse';
import AxisYExtendRangeTrueCode from '!!raw-loader!./examples/AxisYExtendRangeTrue';
import AxisYIncludeZeroFalseCode from '!!raw-loader!./examples/AxisYIncludeZeroFalse';
import AxisYIncludeZeroTrueCode from '!!raw-loader!./examples/AxisYIncludeZeroTrue';
import AxisXIncludeZeroFalseCode from '!!raw-loader!./examples/AxisXIncludeZeroFalse';
import AxisXIncludeZeroTrueCode from '!!raw-loader!./examples/AxisXIncludeZeroTrue';
import AxisXIntegerUnitFalseCode from '!!raw-loader!./examples/AxisXIntegerUnitFalse';
import AxisXIntegerUnitTrueCode from '!!raw-loader!./examples/AxisXIntegerUnitTrue';
import AxisYMajorGridCode from '!!raw-loader!./examples/AxisYMajorGrid';
import AxisXMinorGridCode from '!!raw-loader!./examples/AxisXMinorGrid';
import AxisYMinorGridCode from '!!raw-loader!./examples/AxisYMinorGrid';
import LegendPlacementCode from '!!raw-loader!./examples/LegendPlacement';
import LegendOverflowEndCode from '!!raw-loader!./examples/LegendOverflowEnd';
import LegendOverflowMiddleCode from '!!raw-loader!./examples/LegendOverflowMiddle';
import MarkerSizeCode from '!!raw-loader!./examples/MarkerSize';

import BasicExample from './examples/Basic';
import TitleVisibilityExample from './examples/TitleVisibility';
import TitleSpecifiedExample from './examples/TitleSpecified';
import SeriesColorsExample from './examples/SeriesColors';
import FieldColorsExample from './examples/FieldColors';
import BackgroundColorExample from './examples/BackgroundColor';
import ForegroundColorExample from './examples/ForegroundColor';
import FontColorExample from './examples/FontColor';
import AbbreviationExample from './examples/Abbreviation';
import AxisYScaleExample from './examples/AxisYScale';
import AxisXScaleExample from './examples/AxisXScale';
import AxisYMinNumberExample from './examples/AxisYMinNumber';
import AxisYMaxNumberExample from './examples/AxisYMaxNumber';
import AxisYMajorUnitExample from './examples/AxisYMajorUnit';
import AxisXMinNumberExample from './examples/AxisXMinNumber';
import AxisXMaxNumberExample from './examples/AxisXMaxNumber';
import AxisXMajorUnitExample from './examples/AxisXMajorUnit';
import AxisXLabelRotationExample from './examples/AxisXLabelRotation';
import AxisXVisibilityHideExample from './examples/AxisXVisibilityHide';
import AxisXVisibilityExample from './examples/AxisXVisibility';
import AxisYVisibilityExample from './examples/AxisYVisibility';
import AxisYMajorTicksExample from './examples/AxisYMajorTicks';
import AxisXMajorTicksExample from './examples/AxisXMajorTicks';
import AxisYMinorTicksExample from './examples/AxisYMinorTicks';
import AxisXMinorTicksExample from './examples/AxisXMinorTicks';
import AxisXTicksSizeExample from './examples/AxisXTicksSize';
import AxisYTicksSizeExample from './examples/AxisYTicksSize';
import LabelVisibilityExample from './examples/LabelVisibility';
import AxisXExtendRangeFalseExample from './examples/AxisXExtendRangeFalse';
import AxisXExtendRangeTrueExample from './examples/AxisXExtendRangeTrue';
import AxisYExtendRangeFalseExample from './examples/AxisYExtendRangeFalse';
import AxisYExtendRangeTrueExample from './examples/AxisYExtendRangeTrue';
import AxisYIncludeZeroFalseExample from './examples/AxisYIncludeZeroFalse';
import AxisYIncludeZeroTrueExample from './examples/AxisYIncludeZeroTrue';
import AxisXIncludeZeroFalseExample from './examples/AxisXIncludeZeroFalse';
import AxisXIncludeZeroTrueExample from './examples/AxisXIncludeZeroTrue';
import AxisXIntegerUnitFalseExample from './examples/AxisXIntegerUnitFalse';
import AxisXIntegerUnitTrueExample from './examples/AxisXIntegerUnitTrue';
import AxisYMajorGridExample from './examples/AxisYMajorGrid';
import AxisXMinorGridExample from './examples/AxisXMinorGrid';
import AxisYMinorGridCExample from './examples/AxisYMinorGrid';
import LegendPlacementExample from './examples/LegendPlacement';
import LegendOverflowEndExample from './examples/LegendOverflowEnd';
import LegendOverflowMiddleExample from './examples/LegendOverflowMiddle';
import MarkerSizeExample from './examples/MarkerSize';
import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Scatter"
        examplesSection={[
            <DocExample title="Basic Scatter" key="basic" code={BasicCode} example={BasicExample} />,
            <DocExample
                title="Title of Axis-Y and Axis-X is not visible"
                key="titlevisibility"
                code={TitleVisibilityCode}
                example={TitleVisibilityExample}
            />,
            <DocExample
                title="Title of Axis-Y and Axis-X specified"
                key="titlespecified"
                code={TitleSpecifiedCode}
                example={TitleSpecifiedExample}
            />,
            <DocExample
                title="Series Colors: Red, Blue and Green"
                key="seriescolors"
                code={SeriesColorsCode}
                example={SeriesColorsExample}
            />,
            <DocExample
                title="Field Colors: 200 - Green, 201 - Orange, 401 - Blue, 404 - Olive"
                key="fieldcolors"
                code={FieldColorsCode}
                example={FieldColorsExample}
            />,
            <DocExample
                title="Background Color - Green"
                key="backgroundcolor"
                code={BackgroundColorCode}
                example={BackgroundColorExample}
            />,
            <DocExample
                title="Foreground Color - Red"
                key="foregroundcolor"
                code={ForegroundColorCode}
                example={ForegroundColorExample}
            />,
            <DocExample
                title="Font Color - Blue"
                key="fontcolor"
                code={FontColorCode}
                example={FontColorExample}
            />,
            <DocExample
                title="Axis-Y Abbreviation - On, Axis-X Abbreviation - On"
                key="abbreviation"
                code={AbbreviationCode}
                example={AbbreviationExample}
            />,
            <DocExample
                title="Axis-Y Scale - Log"
                key="axisyscale"
                code={AxisYScaleCode}
                example={AxisYScaleExample}
            />,
            <DocExample
                title="Axis-X Scale - Log"
                key="axisxscale"
                code={AxisXScaleCode}
                example={AxisXScaleExample}
            />,
            <DocExample
                title="Axis-Y Minimum Number - 500"
                key="axisyminnumber"
                code={AxisYMinNumberCode}
                example={AxisYMinNumberExample}
            />,
            <DocExample
                title="Axis-Y Maximum Number - 2,000"
                key="axisymaxnumber"
                code={AxisYMaxNumberCode}
                example={AxisYMaxNumberExample}
            />,
            <DocExample
                title="Axis-Y Major Unit - 100"
                key="axisymajorunit"
                code={AxisYMajorUnitCode}
                example={AxisYMajorUnitExample}
            />,
            <DocExample
                title="Axis-X Minimum Number - 10"
                key="axisxminnumber"
                code={AxisXMinNumberCode}
                example={AxisXMinNumberExample}
            />,
            <DocExample
                title="Axis-X Maximum Number - 20"
                key="axisxmaxnumber"
                code={AxisXMaxNumberCode}
                example={AxisXMaxNumberExample}
            />,
            <DocExample
                title="Axis-X Major Unit - 5"
                key="axisxmajorunit"
                code={AxisXMajorUnitCode}
                example={AxisXMajorUnitExample}
            />,
            <DocExample
                title="Axis-X Label Rotation - 45"
                key="axisxlabelrotation"
                code={AxisXLabelRotationCode}
                example={AxisXLabelRotationExample}
            />,
            <DocExample
                title="Axis-X Visibility - Hide"
                key="axisxvisibilityhide"
                code={AxisXVisibilityHideCode}
                example={AxisXVisibilityHideExample}
            />,
            <DocExample
                title="Axis-X Visibility - Show"
                key="axisxvisibility"
                code={AxisXVisibilityCode}
                example={AxisXVisibilityExample}
            />,
            <DocExample
                title="Axis-Y Visibility - Show"
                key="axisyvisibility"
                code={AxisYVisibilityCode}
                example={AxisYVisibilityExample}
            />,
            <DocExample
                title="Axis-Y Major Ticks - Show"
                key="axisymajorticks"
                code={AxisYMajorTicksCode}
                example={AxisYMajorTicksExample}
            />,
            <DocExample
                title="Axis-X Major Ticks - Show"
                key="axisxmajorticks"
                code={AxisXMajorTicksCode}
                example={AxisXMajorTicksExample}
            />,
            <DocExample
                title="Axis-Y Minor Ticks - Show"
                key="axisyminorticks"
                code={AxisYMinorTicksCode}
                example={AxisYMinorTicksExample}
            />,
            <DocExample
                title="Axis-X Minor Ticks - Show"
                key="axisxminorticks"
                code={AxisXMinorTicksCode}
                example={AxisXMinorTicksExample}
            />,
            <DocExample
                title="Axis-X Major Tick Size - 15, Axis-X Minor Tick Size - 10"
                key="axisxticssize"
                code={AxisXTicksSizeCode}
                example={AxisXTicksSizeExample}
            />,
            <DocExample
                title="Axis-Y Major Tick Size - 15, Axis-Y Minor Tick Size - 10"
                key="axisyticssize"
                code={AxisYTicksSizeCode}
                example={AxisYTicksSizeExample}
            />,
            <DocExample
                title="Axis-X Major Label Visibility - Hide, Axis-Y Major Label Visibility - Hide"
                key="labelvisibility"
                code={LabelVisibilityCode}
                example={LabelVisibilityExample}
            />,
            <DocExample
                title="Axis-X Extend Range - False"
                key="axisxextendrangefalse"
                code={AxisXExtendRangeFalseCode}
                example={AxisXExtendRangeFalseExample}
            />,
            <DocExample
                title="Axis-X Extend Range - True"
                key="axisxextendrangeTrue"
                code={AxisXExtendRangeTrueCode}
                example={AxisXExtendRangeTrueExample}
            />,
            <DocExample
                title="Axis-Y Extend Range - False"
                key="axisyextendrangefalse"
                code={AxisYExtendRangeFalseCode}
                example={AxisYExtendRangeFalseExample}
            />,
            <DocExample
                title="Axis-Y Extend Range - True"
                key="axisyextendrangetrue"
                code={AxisYExtendRangeTrueCode}
                example={AxisYExtendRangeTrueExample}
            />,
            <DocExample
                title="Axis-Y Include Zero - False"
                key="axisyincludezerofalse"
                code={AxisYIncludeZeroFalseCode}
                example={AxisYIncludeZeroFalseExample}
            />,
            <DocExample
                title="Axis-Y Include Zero - True"
                key="axisyincludezerotrue"
                code={AxisYIncludeZeroTrueCode}
                example={AxisYIncludeZeroTrueExample}
            />,
            <DocExample
                title="Axis-X Include Zero - False"
                key="axisxincludezerofalse"
                code={AxisXIncludeZeroFalseCode}
                example={AxisXIncludeZeroFalseExample}
            />,
            <DocExample
                title="Axis-X Include Zero - True"
                key="axisxincludezerotrue"
                code={AxisXIncludeZeroTrueCode}
                example={AxisXIncludeZeroTrueExample}
            />,
            <DocExample
                title="Axis-X Integer Unit - False"
                key="axisxintegerunitfalse"
                code={AxisXIntegerUnitFalseCode}
                example={AxisXIntegerUnitFalseExample}
            />,
            <DocExample
                title="Axis-X Integer Unit - True"
                key="axisxintegerunittrue"
                code={AxisXIntegerUnitTrueCode}
                example={AxisXIntegerUnitTrueExample}
            />,
            <DocExample
                title="Axis-Y Major Grid - False"
                key="axisymajorgrid"
                code={AxisYMajorGridCode}
                example={AxisYMajorGridExample}
            />,
            <DocExample
                title="Axis-Y Minor Grid - True"
                key="axisyminorgrid"
                code={AxisYMinorGridCode}
                example={AxisYMinorGridCExample}
            />,
            <DocExample
                title="Axis-X Minor Grid - True"
                key="axisxminorgrid"
                code={AxisXMinorGridCode}
                example={AxisXMinorGridExample}
            />,
            <DocExample
                title="Legend Placement - Top"
                key="legendplacement"
                code={LegendPlacementCode}
                example={LegendPlacementExample}
            />,
            <DocExample
                title="Legend Overflow Mode - Middle"
                key="legendoverflowmiddle"
                code={LegendOverflowMiddleCode}
                example={LegendOverflowMiddleExample}
            />,
            <DocExample
                title="Legend Overflow Mode - End"
                key="legendoverflowend"
                code={LegendOverflowEndCode}
                example={LegendOverflowEndExample}
            />,
            <DocExample
                title="Marker Size - 8"
                key="markersize"
                code={MarkerSizeCode}
                example={MarkerSizeExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
        eventSection={
            <EventsDoc
                encoding={{
                    category: 'primary.status',
                    x: 'primary.date_hour',
                    y: 'primary.count',
                }}
                events={doc.events}
                Visualization={Scatter}
                dsState={{
                    primary: {
                        requestParams: { offset: 0, count: 20 },
                        data: {
                            fields: [
                                {
                                    name: 'date_hour',
                                },
                                {
                                    name: 'count',
                                },
                                {
                                    name: 'mode(status)',
                                },
                                {
                                    name: 'status',
                                },
                            ],
                            columns: [
                                [
                                    '13',
                                    '14',
                                    '15',
                                    '16',
                                    '17',
                                    '18',
                                    '19',
                                    '10',
                                    '20',
                                    '21',
                                    '22',
                                    '23',
                                    '3',
                                    '4',
                                    '5',
                                ],
                                [
                                    '1109',
                                    '1108',
                                    '1098',
                                    '1088',
                                    '1097',
                                    '1086',
                                    '1107',
                                    '1090',
                                    '1150',
                                    '2100',
                                    '1070',
                                    '1097',
                                    '1096',
                                    '1107',
                                    '1152',
                                ],
                                [
                                    '401',
                                    '201',
                                    '401',
                                    '201',
                                    '401',
                                    '201',
                                    '201',
                                    '401',
                                    '201',
                                    '404',
                                    '201',
                                    '200',
                                    '201',
                                    '201',
                                    '404',
                                    '401',
                                ],
                                [
                                    '401',
                                    '201',
                                    '401',
                                    '201',
                                    '401',
                                    '201',
                                    '201',
                                    '401',
                                    '201',
                                    '201',
                                    '201',
                                    '200',
                                    '201',
                                    '201',
                                    '404',
                                    '401',
                                ],
                            ],
                        },
                        meta: { totalCount: 20 },
                    },
                }}
            />
        }
    />
);
